import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgMarketChangesIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={0.5}
      d="M2.498 1.988a.5.5 0 0 0-.492.506v26.87a.5.5 0 0 0 .142.497.5.5 0 0 0 .489.135h26.869a.5.5 0 1 0 0-1h-26.5V2.494a.5.5 0 0 0-.508-.506Zm26.016 6.026c-.823 0-1.5.677-1.5 1.5 0 .257.073.496.19.71l-7.116 7.905a1.476 1.476 0 0 0-1.217.035l-1.262-1.262a5.038 5.038 0 0 0 .237-3.215c-.704-2.676-3.444-4.266-6.104-3.54-2.66.725-4.25 3.497-3.545 6.173a4.94 4.94 0 0 0 1.172 2.098l-3.137 2.79a1.474 1.474 0 0 0-.718-.194c-.823 0-1.5.677-1.5 1.5 0 .822.677 1.5 1.5 1.5.822 0 1.5-.678 1.5-1.5a1.49 1.49 0 0 0-.114-.563l3.223-2.865a4.95 4.95 0 0 0 2.184.902l.427 1.627a.5.5 0 0 0 .616.356l.02-.006 1.316 5.006a1.476 1.476 0 0 0 1.802 1.037h.002a1.492 1.492 0 0 0 1.047-1.807l-.38-1.435-.196-.748-.23-.883-.274-1.04-.238-.906a.5.5 0 0 0 .347-.607l-.437-1.664c.386-.314.708-.69.984-1.098l1.053 1.053c-.099.2-.15.418-.152.64 0 .823.677 1.5 1.5 1.5.822 0 1.5-.677 1.5-1.5 0-.257-.073-.498-.19-.71l7.117-7.907c.177.074.37.118.573.118.822 0 1.5-.678 1.5-1.5 0-.823-.678-1.5-1.5-1.5Zm0 1c.282 0 .5.218.5.5s-.218.5-.5.5a.492.492 0 0 1-.5-.5c0-.282.218-.5.5-.5ZM12.797 10.98a3.966 3.966 0 0 1 4.084 2.972 4.045 4.045 0 0 1-.041 2.182l-.98-.979c.096-.195.154-.41.154-.64 0-.823-.678-1.5-1.5-1.5-.823 0-1.5.677-1.5 1.5 0 .2.04.388.113.562l-3.014 2.68a3.986 3.986 0 0 1-.95-1.7c-.568-2.156.7-4.36 2.835-4.943.267-.073.534-.118.799-.134Zm1.717 3.035c.282 0 .5.218.5.5s-.218.5-.5.5a.493.493 0 0 1-.33-.13.5.5 0 0 0-.06-.066.493.493 0 0 1 .39-.805zm-.717 1.806c.214.12.456.194.717.194.23 0 .445-.059.64-.153l1.252 1.252a4.002 4.002 0 0 1-2.361 1.783 3.925 3.925 0 0 1-3.16-.486zm5.717 3.194c.282 0 .5.218.5.5s-.218.5-.5.5a.492.492 0 0 1-.5-.5c0-.282.218-.5.5-.5Zm-4.266.484.225.86-1.9.515-.223-.85a4.96 4.96 0 0 0 1.898-.525Zm.006 1.955.236.9.274 1.038.23.88.197.75.38 1.436a.475.475 0 0 1-.342.584.449.449 0 0 1-.577-.326l-1.318-5.012zm-9.74.56c.14 0 .265.054.355.143.09.09.145.217.145.358 0 .282-.218.5-.5.5a.492.492 0 0 1-.5-.5c0-.282.218-.5.5-.5Z"
    />
  </svg>
);
export default SvgMarketChangesIcon;
